import React from "react";
import KickImage from 'Reuseables/KickImage';

import { Container, Row, Col } from "reactstrap";

import KredivoTag from "./KredivoTag";
import PreVerified from "../../../../../../images/pre_verified.png";

export default class SneakerCondition extends React.Component {
  renderPreVerified() {
    if (this.props.selectedSneaker === undefined) {
      return null;
    } else if (this.props.selectedSneaker.pre_verified === false) {
      return null;
    }
    return (
      <div className="condition__pre_verified">
        <div className="pre__verified_icon">
          <KickImage src={PreVerified} />
        </div>
        <p>
          <span>Instant Shipping :</span> 1 Day ETA
        </p>
      </div>
    );
  }

  renderInstallments() {
    if (this.props.showInstallments) {
      return <KredivoTag installments={this.props.installments} />;
    }
    return null;
  }

  extraDescription() {
    if (this.props.isCollapse === "PO") {
      return (
        <Row className="details__condition">
          <Col>
            <p>
              <span>Pre-Order :</span> 3-5 Weeks ETA
            </p>
          </Col>
        </Row>
      );
    }
    return null;
  }

  render() {
    // console.log('PROPS KONDISI ', this.props);

    let yellowing =
      this.props.selectedSneaker === undefined
        ? ""
        : this.props.selectedSneaker.yellowing
        ? ", Yellowing"
        : null;
    let aksesories =
      this.props.selectedSneaker === undefined
        ? ""
        : this.props.selectedSneaker.missing_accessories
        ? " Missing Accessories"
        : " Complete";
    let defected =
      this.props.selectedSneaker === undefined
        ? ""
        : this.props.selectedSneaker.sneakers_defect
        ? ", Defect"
        : null;
    return (
      <Container className="description__wrapper">
        {/* { this.extraDescription() }
        <Row>
          <Col>
            { this.renderPreVerified() }
          </Col>
        </Row> */}
        {/* <Row className="details__condition"> */}
        {/* <Col xs={6}>
            <div> */}
        {/* <p>
                Box -
                <span className="box-condition">
                  { 
                    this.props.selectedSneaker === undefined ? '' :
                    this.props.selectedSneaker.box_condition === 'SEMPURNA' ? ' Perfect Condition' : 
                    this.props.selectedSneaker.box_condition === 'CACAT' ? ' Defect' : 
                    ' Missing Box'
                  }
                </span>
              </p>
              <p>
                Accessories - 
                <span className="box-condition">
                  {aksesories}{yellowing}{defected}
                </span>
              </p> */}
        {/* <p>
                Note Tambahan:  {this.props.selectedSneaker === undefined ? '-' : this.props.selectedSneaker.note === '' ? '  -' : this.props.selectedSneaker.note}
              </p> */}
        {/* </div>
          </Col> */}
        {/* <Col xs={12} className="price" style={{display: 'flex', justifyContent: 'flex-end'}}>
            {this.renderInstallments()}
          </Col> */}
        {/* </Row> */}
        <Row>
          <Col xs={12} className="size-footer">
            {/* className="panduan-container" */}
            <Container>
              <Row>
                <Col xs={12} className="d-none">
                  <a href="#">Panduan Size</a>
                  <a href="#">Tidak melihat size Anda?</a>
                </Col>
              </Row>
            </Container>

            {/* <Container className="other-info-container">
                <Row className="desc__sku">
                  <div>
                    <p className="text-center">{this.props.sku}</p>
                  </div>
                  <div>
                    <p className="text-right">{this.props.colourWay}</p>
                  </div>
                    {/* <Col xs={12} md={4}>
                        <p>{this.props.box_condition === undefined ? '-' : (this.props.box_condition === 'SEMPURNA' ? 'ORIGINAL BOX' : (this.props.box_condition === 'CACAT' ? 'DAMAGED BOX' : 'Missing Box'))}</p>
                    </Col> */}
            {/* <Col xs={12} md={3}>
                    </Col>
                    <Col xs={12} md={3} /> 
                    <Col xs={12} md={5}>
                        
                    </Col> */}
            {/* </Row>
            </Container> */}
          </Col>
        </Row>
      </Container>
    );
  }
}
